/**
 * Debounce function - delays execution until after a specified time has
 * elapsed since the last time it was invoked.
 *
 * @param {Function} func - The function to debounce
 * @param {number} timeout - The number of milliseconds to delay
 * @returns {Function} - The debounced function
 */
// eslint-disable-next-line import/prefer-default-export
export function debounce(func, timeout = 300) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => { func.apply(this, args); }, timeout);
  };
}

export function snakeCaseToTitleCase(snakeCaseString) {
  if (!snakeCaseString) {
    return '';
  }

  return snakeCaseString
    .split('_')
    .filter((word) => word.length > 0)
    .map((word) => `${word.charAt(0).toUpperCase()}${word.slice(1).toLowerCase()}`)
    .join(' ');
}
